var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSveaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "site-logo-svg",
    viewBox: "0 0 181.9 67.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 18.6H16.6c-4.5 0-5-2.2-5-4 0-3.5 1.8-5 6.3-5h24V0H16.5C5.3 0 0 4.6 0 14.6c0 9.3 5 13.7 15.7 13.7h11.1c4.3 0 5.8 1 5.8 4.3 0 2.7-1 4.1-6.4 4.1H1.8v9.7h25.9c11.2 0 16.5-4.5 16.5-14.2S39.8 18.6 29 18.6zM81.9 0 68.8 31.8 55.9 0H43.3l20.3 46.4h10.8L93.8 0zm31.3 9.5h16.3V0H113C98.1 0 91.1 7.6 91.1 24c0 8.5 2.4 14.4 7.2 18.3 4.8 3.8 9.4 4.1 14.5 4.1h16.7v-9.6h-16.3c-6.7 0-9.4-2.5-9.7-9.1h26v-9.5h-25.9c.6-5.9 3.7-8.7 9.6-8.7zM151.1 0l-19.6 46.4h11.9l4-10.6h18.1l4.1 10.6H182L162.2 0h-11.1zm-.1 26 5.2-13.8 5.4 13.8H151z",
    className: "site-logo-svg__text-path"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00aece",
    d: "M3.7 55.2h176c1.2 0 2.2 1 2.2 2.2V65c0 1.2-1 2.2-2.2 2.2H3.7c-1.2 0-2.2-1-2.2-2.2v-7.6c0-1.2 1-2.2 2.2-2.2z",
    className: "site-logo-svg__underline-path"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSveaLogo);
export default __webpack_public_path__ + "static/media/svea-logo.b4a1c7025c4b3e50378fbb0cea4fddc8.svg";
export { ForwardRef as ReactComponent };